<template>
  <el-form-item :label="label" class="school">
    <el-checkbox v-model="inputValue" @change="checkChange" label="仅看登记校区为所选校区的学员" />
  </el-form-item>
</template>
<script>
import { inject } from 'vue';

export default {
  kind: 'yq-校区范围选择',
  props: {
    value: [String, Number, Array, Date, Boolean], // 绑定的值
    label: String,
  },
  setup(props) {
    const useQuery = inject('useQuery');
    const reset = () => {
      // eslint-disable-next-line no-use-before-define
      inputValue.value = props.value;
    };
    const inputValue = useQuery('onlyQueryRegisterCampus', props.value, reset);
    function checkChange(v) {
      console.log(v);
    }
    return {
      props,
      inputValue,
      checkChange,
    };
  },
};
</script>
<style lang="scss" scoped>
.school{
  :deep(.el-form-item__content){
    margin-left: 4px;
  }
}

</style>
